<template>
    <div>
        <div>
            <el-form :model="form" :inline="true"  style="text-align:left;">
                <el-form-item label="综合查询:">
                    <el-input v-model="form.name" placeholder="请输入收货人姓名/收货人电话"  :clearable="true" class="query-input"></el-input>
                </el-form-item> 
                <el-form-item label="省市区:" class="readdress-select">
                      <el-cascader
                        v-model="form.area"
                        placeholder="请选择省市区"
                        :props="queryProps"                      
                        clearable                       
                        ></el-cascader>               
                </el-form-item> 
                <el-form-item >
                    <el-button type="primary" plain @click="query()">查询</el-button>  
                    <el-button type="primary" plain @click="receivingEditor('add')">新建</el-button>                         
                </el-form-item>           
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable">           
                <template #operation="scope">        
                    <el-button size="mini" type="primary" @click="receivingEditor('update',scope.row)">修改</el-button>
                    <el-button size="mini" type="primary" @click="receivingDelete(scope.row)">删除</el-button>
                </template>
            </My-table> 
        </div>
        
        <el-dialog :title="title" :visible.sync="receivingDialog" :close-on-click-modal=false width="1000px">
            <el-form :model="editorForm"  :inline="true"    :rules="rules" ref="editorForm" label-width="100px" style="text-align:left">
                <el-form-item label="收货人姓名:" prop="userName" class="goods-input">
                    <el-input v-model="editorForm.userName" placeholder="请输入收货人姓名"></el-input>
                </el-form-item>
                <el-form-item label="收货人电话:" prop="phone" class="goods-phone-input">
                    <el-input v-model="editorForm.phone" placeholder="请输入收货人电话"></el-input>
                </el-form-item>
                <el-form-item label="地址:" prop="area" class="readdress-select">
                 <el-cascader 
                        v-model="editorForm.area"
                        placeholder="请选择省市区"
                        :props="props"
                        :options="options_cascader"
                        :key="isResouceShow"                       
                    ></el-cascader>                
                </el-form-item>
                <el-form-item label="" prop="address" class="address-input">
                    <el-input v-model="editorForm.address" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="状态:" prop="state" >
                    <el-switch v-model="editorForm.state"></el-switch>
                </el-form-item>               
            </el-form>
            <div slot="footer" style="text-align:center">
                <el-button type="primary" @click="submitForm('editorForm')">确定</el-button>
                <el-button @click="resetForm('editorForm')">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import common from "../../../public/static/common.js";
import  asyncApi   from '../../api/asyncApi';

export default {
    name: 'serviceProject',
    data(){
        let recme = this;
        return{
            
            title:'',
            placeholder:'请选择查询状态',
            form:{
                name:'',
                areaProvince:'',
                areaCity:'',
                areaCounty:'',
                area:''
            },
            editorForm:{
                id:'',
                userName:'',                
                phone:'',  
                areaProvince:'',              
                areaCity:'',
                areaCounty:'',              
                address:'',
                createUser:'',
                modifyUser:'',
                state:true,
                area:[]
            },
             // 列表配置
            configurationData:[
                {
                    title: '收货人姓名',
                    propertys: 'userName',
                    width: ''
                },
                {
                    title: '收货人电话',
                    propertys: 'phone',
                    width: ''
                },
                {
                    title: '省市区',
                    propertys: 'addressLink',
                    width: ''
                },
                {
                    title: '详细地址',
                    propertys: 'address',
                    width: ''
                },
                {
                    title: '状态',
                    propertys: 'state',
                    width: '',
                    format:common.formatState
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/addressManage/page',
                param:''
            },
            receivingDialog:false,
            operationType:'',
            rules: {
                userName: [
                    { required: true, message: '请输入收货人姓名', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入收货人电话/手机号格式不正确', pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }
                ],
                area: [
                    { required: true, message: '请输入收货人地址', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请输入收货人详细地址', trigger: 'blur' }
                ],
                state: [
                    { required: true, trigger: 'blur' }
                ]
            },
            districtList: [],
            options_cascader:[],
            isResouceShow: "0",
            props:{
                value: 'name',
                label: 'name',
                children: 'cities' ,
                lazy: true,
                async lazyLoad (node, resolve) {                  
                    const { level } = node;
                    let nodes = [];
      
                    if(level ==0){
                        await recme.getProvince();
                        nodes = recme.provinceList;
                    }
                    if(level ==1){
                        await recme.getCity(node.data.code);                       
                        nodes = recme.cityList;
                    }
                    if(level ==2){
                        await recme.getDistricts(node.data.code);                       
                        nodes = recme.districtList;
                        nodes.forEach(element => {
                            element.leaf = true;
                        });
                    }
                    setTimeout(() => {                       
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    }, 200);
                }               
            },
            queryProps:{
                value: 'name',
                label: 'name',
                children: 'cities' ,
                checkStrictly :true,
                lazy: true,
                async lazyLoad (node, resolve) {                  
                    const { level } = node;
                    let nodes = [];
      
                    if(level ==0){
                        await recme.getProvince();
                        nodes = recme.provinceList;
                    }
                    if(level ==1){
                        await recme.getCity(node.data.code);                       
                        nodes = recme.cityList;
                    }
                    if(level ==2){
                        await recme.getDistricts(node.data.code);                       
                        nodes = recme.districtList;
                        //console.log(nodes);

                        nodes.forEach(element => {
                            element.leaf = true;
                        });
                    }
                    setTimeout(() => {                       
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    }, 200);
                }               
            },
            provinceList:[], 
            cityList:[],
            
        }
    },
    methods:{

        receivingEditor(operationType,row){
  
            this.operationType=operationType;
            if(operationType=='update'){ 
                
                this.title="收货信息修改";
                this.editorForm.area= [];    
                this.options_cascader=[];
                ++this.isResouceShow;                
                this.editorForm.id=row.id;
                this.editorForm.userName=row.userName;
                this.editorForm.phone=row.phone;
                this.editorForm.address=row.address;               
                this.editorForm.area=[row.areaProvince,row.areaCity,row.areaCounty];
 
                if(row.state=='N'){
                    this.editorForm.state=false;
                }else{
                    this.editorForm.state=true;
                }
                //console.log(this.editorForm);
            }else{
                //添加
                this.title="收货信息新增";
                this.editorForm.state=true;              
                this.editorForm=common.emptyModel(this.editorForm,["state"]);
            }
            this.$nextTick(() => {                
                this.receivingDialog=true;
            });
           
        },
        query(){
            let param=Object.assign({},this.form); 
            if(param.area[0]){
                param.areaProvince=param.area[0];
            }
            if(param.area[1]){               
                param.areaCity=param.area[1];
            }
            if(param.area[2]){
                param.areaCounty=param.area[2];
            }

            this.getTableParam.param=param;
            this.$refs.myTable.query(1);
        },
        submitForm(formName) {
            let usercode=common.getCurrUser().userCode;
            let url="";
            let param=Object.assign({},this.editorForm);            
            if(param.state){
                param.state='Y'
            }else{
                param.state='N'
            }
            param.createUser=usercode;
            param.modifyUser=usercode;
            param.areaProvince=param.area[0];
            param.areaCity=param.area[1];
            param.areaCounty=param.area[2];           
            
            if(this.operationType=='add'){
                url="/extwarapi/api/addressManage/add";
            }else{
                url="/extwarapi/api/addressManage/update";
            }
            //console.log(param);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.axios.post(url, param).then((resp) => {
                        if(resp.data.code=='0000'){
                            this.$alert("操作成功!", '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.receivingDialog=false;
                                    this.$refs["myTable"].query(1); 
                                }
                            });
                        }else{
                            this.$alert(resp.data.msg, '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                
                                }
                             });
                            return;
                        }
               
                    }).catch((resp) => {
                        //console.log('error', resp); 
                    })
                } else {
                    //console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.receivingDialog=false;
            this.$refs[formName].resetFields();            
        },
        receivingDelete(row){
            let url='/extwarapi/api/addressManage/delete';
            let param={
                id:row.id,
                modifyUser:'',
                };
            this.$confirm('确定删除吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.axios.post(url, param).then((resp) => {  
                            this.receivingDialog=false;
                            this.$refs["myTable"].query();                
                        }).catch((resp) => {
                            //console.log('error', resp); 
                        })
                    }).catch(() => {
                        this.receivingDialog=false;   
                    });
        },      
       async  getProvince () { 
            let url ="/extwarapi/api/tools/getProvince";
            let data = await asyncApi.post(url,{});  
            if(data.code=='0000'){
                this.provinceList= common.conversionList(data.result,'provinceCode','code','provinceName','name');
            }
        },
        async  getCity (code) {
            let url ="/extwarapi/api/tools/getCity";
            let data = await asyncApi.post(url,{code:code});  
            if(data.code=='0000'){
                this.cityList= common.conversionList(data.result,'cityCode','code','cityName','name');
            }
        },
        async  getDistricts (code) {
            let url ="/extwarapi/api/tools/getDistricts";
            let data = await asyncApi.post(url,{code:code});  
            if(data.code=='0000'){
                this.districtList= common.conversionList(data.result,'districtCode','code','districtName','name');
            }
        },
     
   
  },
       
    

 
}
</script>
<style lang="scss" >
.address-input .el-form-item__content{
    width: 400px;
}
.readdress-select .el-input--suffix{
    width: 400px;
}
.goods-input .el-input{
    width: 400px;
}
.goods-phone-input .el-input{
    width: 300px;
}
</style>